import { useStore } from '../../../../hooks/useStore';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../../lib/components';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { ProfilePictureView } from './view';
import { ProfilePictureForm } from './form';
import { ProfileViewEditBox } from '../shared/profileViewEditBox';
import { enqueueSnackbar } from 'notistack';

export const EmployeeProfilePictureUpload = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const form = useForm();

  const renderView = observer(() => {
    return <ProfilePictureView data={employeeStore.currentEmployee?.general_data} />;
  });

  const renderEdit = () => {
    return (
      <ProfilePictureForm
        initialValues={{
          profile_picture: employeeStore.currentEmployee?.general_data.profile_picture
        }}
        formRef={form.formRef}
        onSubmit={async (values) => {
          try {
            if (!employeeId) return;

            await employeeStore.updateEmployeeGeneralData(employeeId, {
              profile_picture: values.profile_picture[0]
                ? {
                    name: values.profile_picture[0].name,
                    encoded_string: values.profile_picture[0].file
                  }
                : { name: '-', encoded_string: '-' }
            });
            enqueueSnackbar(t('employee:PROFILE_UPDATED'), { variant: 'success' });
          } catch (error) {
            console.log(error);
            enqueueSnackbar(t('employee:PROFILE_UPDATED'), { variant: 'success' });
          }
        }}
      />
    );
  };

  useEffect(() => {
    const fn = async () => {
      await employeeStore.getGeneralData(employeeId ?? '');
    };
    fn();
  }, [employeeStore.currentEmployee?.general_data]);

  return (
    <ProfileViewEditBox
      title={t('employee:PROFILE_PICTURE')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={true}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
